import * as yup from 'yup';

export const insightsReportFormValidationSchema = yup.object({
  reportType: yup.string().required(),
  reportSchedule: yup.array().min(1, { id: 'insights.reports.frequency.error-required' }).required(),
  venueIds: yup.array().min(1, { id: 'insights.reports.venues.error-required' }).required(),
  metrics: yup.array().min(1, { id: 'insights.reports.data-options.error-required' }).required(),
  dataAggregationLevel: yup.string().when('$aggregations', {
    is: (aggregations: string[]) => aggregations.length > 0,
    then: yup.string().required(),
  }),
});
